import { useSyncExternalStore } from 'react';

interface Toast {
  id: number;
  text: string;
  art: 'erfolg' | 'fehler';
}

let liste: Toast[] = [];
let naechste = 1;
const hoerer = new Set<() => void>();
const melden = () => hoerer.forEach((h) => h());

/** Kurze Bestätigung unten in der Mitte, verschwindet nach 3,5 s */
export function toast(text: string, art: Toast['art'] = 'erfolg'): void {
  const id = naechste++;
  liste = [...liste, { id, text, art }];
  melden();
  setTimeout(() => {
    liste = liste.filter((t) => t.id !== id);
    melden();
  }, 3500);
}

export function Toasts() {
  const aktuell = useSyncExternalStore(
    (cb) => {
      hoerer.add(cb);
      return () => hoerer.delete(cb);
    },
    () => liste,
    () => liste,
  );
  return (
    <div className="dxl-toasts" role="status" aria-live="polite">
      {aktuell.map((t) => (
        <div key={t.id} className={`dxl-toast dxl-toast--${t.art}`}>
          {t.art === 'erfolg' ? (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
              <path d="M20 6 9 17l-5-5" />
            </svg>
          ) : (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" aria-hidden>
              <path d="M12 8v5M12 16.5v.5" />
              <circle cx="12" cy="12" r="9" />
            </svg>
          )}
          {t.text}
        </div>
      ))}
    </div>
  );
}
